import React from 'react';
import Modal from '../Modal';

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  text,
  title = 'Weet je het zeker?',
  confirmLabel = 'Doorgaan',
  cancelLabel = 'Annuleren',
}) => {
  return (
    <Modal
      title={title}
      state={isOpen ? 'open' : 'closed'}
      onClose={onClose}
      actions={[
        {
          type: 'secondary',
          label: cancelLabel,
          onClick: onClose,
        },
        {
          type: 'primary',
          label: confirmLabel,
          onClick: onConfirm,
        },
      ]}
    >
      <p>{text}</p>
    </Modal>
  );
};

export default ConfirmationModal;

export interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  text: string;
  title?: string;
  confirmLabel?: string;
  cancelLabel?: string;
}
